import { render, staticRenderFns } from "./customer-view-toolbar.vue?vue&type=template&id=6bc82c94&"
import script from "./customer-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./customer-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports